// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collection-filter[data-v-28837aa8]{width:320px;min-width:320px}@media only screen and (max-width:768px){.collection-filter[data-v-28837aa8]{min-width:unset;position:fixed;top:0;right:0;bottom:0;left:0;width:100%;visibility:hidden;transition:opacity .2s ease-out 0s,visibility .2s ease 0s;opacity:0}.collection-filter.active[data-v-28837aa8]{visibility:visible;opacity:1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
